(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["instagram-collage"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const videos = new Set();
    const nearby = new WeakSet();
    const play = (video) => {
      if (document.hidden || !nearby.has(video)) return;
      video.muted = true;
      video.play().catch(() => {});
    };
    const prepare = (video) => {
      let changed = false;
      video.querySelectorAll('source[data-src]').forEach((source) => {
        source.src = source.dataset.src;
        source.removeAttribute('data-src');
        changed = true;
      });
      if (changed) video.load();
      play(video);
    };
    const observer = 'IntersectionObserver' in window
      ? new IntersectionObserver((entries) => {
          entries.forEach(({ target: video, isIntersecting }) => {
            if (isIntersecting) {
              nearby.add(video);
              prepare(video);
            } else {
              nearby.delete(video);
              video.pause();
            }
          });
        }, { rootMargin: '200px 0px' })
      : null;
    const init = (root) => {
      root.querySelectorAll('.instagram-collage__video').forEach((video) => {
        if (videos.has(video)) return;
        videos.add(video);
        if (observer) observer.observe(video);
        else {
          nearby.add(video);
          prepare(video);
        }
      });
    };
    init(document);
    document.addEventListener('shopify:section:load', (event) => init(event.target));
    document.addEventListener('shopify:section:unload', (event) => {
      event.target.querySelectorAll('.instagram-collage__video').forEach((video) => {
        if (observer) observer.unobserve(video);
        nearby.delete(video);
        videos.delete(video);
        video.pause();
      });
    });
    document.addEventListener('visibilitychange', () => {
      videos.forEach((video) => document.hidden ? video.pause() : play(video));
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
